export default __webpack_public_path__ + "static/media/Astro_Square_White.4125dd1c.png";